import {
  FILTERS_PROPS as LOC_FILTER_PROPS,
  LOCATION_FILTER_KEYS,
} from '../../Constants/Filters/LocationFilter.constants';
import { FILTERS_NOT_FOR_DISPLAY, filterKeys } from '../../Constants/SearchFilters';
import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';
import type { FilterValueDisplayObj } from '../../Entities/Search/SearchFilters/FilterValueDisplayObj.entity';
import { VEHICLE_STATUS_VALUES } from '../../Services/Search/Search.constants';

export const mapFiltersForDisplay = (filters: Filter[]) => {
  const outputFilters: FilterValueDisplayObj[] = [];

  const hasAreaFilter = filters.some(filter => filter.id === 'area');

  filters
    .filter(filter => filterKeys.includes(filter.id))
    .forEach(filter => {
      if (FILTERS_NOT_FOR_DISPLAY.includes(filter.id)) return;
      if (hasAreaFilter && (filter.id === 'postcode' || filter.id === 'max-distance')) return;
      if (filter.id === 'vehicle-status' && filter.value === VEHICLE_STATUS_VALUES.includeSold)
        return;

      const filterNameParts = filter.id.split('__');
      const locationFilterObj = LOC_FILTER_PROPS.find(locFltr => locFltr.key === filter.id);
      const filterNamePure = locationFilterObj?.filterType ?? filterNameParts[0];
      const filterFn = filterNameParts[1];
      const isLocationFilter = LOCATION_FILTER_KEYS.includes(filter.id);

      if (filterFn || isLocationFilter) {
        const rangeProp: Record<string, string> = {
          gte: 'valueGte',
          lte: 'valueLte',
        };

        const existingRecord = outputFilters.find(fltr => fltr.id === filterNamePure);
        const valueProp = rangeProp[filterFn] || filter.id;
        if (existingRecord) {
          existingRecord[valueProp] = filter.value;
          existingRecord.originalFilters = [...existingRecord.originalFilters, filter];
        } else {
          outputFilters.push({
            id: filterNamePure,
            originalFilters: [
              { ...filter },
              ...(isLocationFilter ? [{ id: 'max-distance', value: undefined } as Filter] : []),
            ],
            [valueProp]: filter.value,
          });
        }
      } else if (Array.isArray(filter.value)) {
        filter.value.forEach(value => {
          outputFilters.push({
            ...(filter as FilterValueDisplayObj),
            value,
            originalFilters: [filter],
          });
        });
      } else {
        outputFilters.push({
          ...(filter as FilterValueDisplayObj),
          originalFilters: [filter],
        });
      }
    });

  return outputFilters;
};
